module.exports = __webpack_public_path__ + "img/phone_verification.84d57e08.svg";